import { createTheme } from '@mui/material/styles';

// Your branding colors
const kBrandedPrimary = '#013b6d'; // Color(0xFF013b6d)
const kBrandedAccent = '#f5b916';  // Color(0xFFf5b916)

const theme = createTheme({
  palette: {
    primary: {
      main: kBrandedPrimary,
      light: '#345d8c',
      dark: '#00214a',
      contrastText: '#ffffff',
    },
    secondary: {
      main: kBrandedAccent,
      light: '#f7c94a',
      dark: '#d89c00',
      contrastText: '#000000',
    },
    background: {
      default: '#ffffff',
      paper: '#f8f9fa',
    },
    text: {
      primary: '#333333',
      secondary: '#666666',
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 800,
    },
    h2: {
      fontWeight: 700,
    },
    h3: {
      fontWeight: 600,
    },
    h4: {
      fontWeight: 600,
    },
    h5: {
      fontWeight: 600,
    },
    h6: {
      fontWeight: 500,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        },
      },
    },
  },
});

export default theme;